import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    // Focus on textarea after modal is shown
    this.element.addEventListener('shown.bs.modal', () => {
      this.element.querySelector('textarea').focus()
    }, { once: true })
  }

  success(event) {
    const [data, status, xhr] = event.detail
    if (status === "OK" || status === "Created") { // Handle both update and create
        this.hide()
    }
  }

  hide() {
    const modal = Modal.getInstance(this.element)
    if (modal) {
      modal.hide()
    }
  }
}

